import React from 'react'

function ListMexHeader() {
    return (
        <thead className='thead-light ListMexHeader'>
            <tr>
                <th className='name'>Tên lô</th>
                <th className='create_at'>Ngày tạo</th>
                <th className='type'>Loại sản phẩm</th>
                <th className='status text-center'>Trạng thái</th>
                <th className='quanlity'>Số lượng</th>
                <th className='mex_user'>Người ép mex</th>
                <th className='partner'>Đối tác in ép</th>
                <th className='sewing_partner'>Đối tác may</th>
                <th className='user_create'>Người tạo</th>
                <th className='mex_date'>Ngày ép mex</th>
            </tr>
        </thead>
    )
}

export default ListMexHeader